module.exports = __webpack_public_path__ + "img/big_phone.36944b07.png";